import React, { Component, Fragment } from "react";
import Helmet from "react-helmet";

import { title, List } from "utils";

import { Header } from "components";
import { Button, Switch, Icon } from "antd";

class NoteListPage extends Component {
  constructor(props) {
    super(props);

    const { type } = this.props;
  }

  render() {
    const bread = [{ text: "Liste des non-conformités" }];
    const { type } = this.props;

    //const filters = { type_id: type }
    const headerTitle = "Non-conformités",
      page = "compliances";

    return (
      <Fragment>
        <Helmet>{title("Liste des notes")}</Helmet>

        <div className="note-list-page main-content">
          <Header title={headerTitle} bread={bread} />
          <List type={page} />
        </div>
      </Fragment>
    );
  }
}

export default NoteListPage;
